/** The print page's calls: the one-time code from /print/<code> goes in the body. */

import { apiCall } from '../api.ts';
import type { OpenedShare } from '../share/public-share-api.ts';
import type { WidgetResult } from '../reports/reports-api.ts';

export type OpenedPrint = Omit<Extract<OpenedShare, { locked: false }>, 'locked' | 'share'>;

const post = <T>(path: string, body: Record<string, unknown>) =>
  apiCall<T>(`/public/print/${path}`, { method: 'POST', body: JSON.stringify(body) });

/** The code from a /print/<code> address, or null on any other page. */
export function printTokenFromUrl(): string | null {
  const match = /^\/print\/([A-Za-z0-9_-]{10,100})\/?$/.exec(window.location.pathname);
  return match ? (match[1] as string) : null;
}

export const printApi = {
  open: (token: string) => post<OpenedPrint>('open', { token }),
  query: (token: string, page: number) =>
    post<{ results: WidgetResult[]; range: { from: string; to: string } }>('query', {
      token,
      page,
    }),
};
